module.exports = __webpack_public_path__ + "static/img/btn_2.f687801b.png";